import {SignUpComponent} from "../SignUpComponent.js";

export class LoadingPopup extends SignUpComponent {
    template() {
        const {loadingText = i18next.t(main.alert.signupProcessing) , isNoLoadingText = false} = this.$props;
        return `
             <section id="popDimmed" class="spinner-loading-pop" style="display: flex;">
              <article>
                <div class="pop-cont">
                  <div class="loading type2">
                    <i class="circle"></i>
                    <i class="circle"></i>
                    <i class="circle"></i>
                    <i class="circle"></i>
                    <i class="circle"></i>
                  </div>
                  <div>
                    <p>${loadingText}</p>
                    <p>${isNoLoadingText ? "" : i18next.t(common.wait) + '...' }</p>
                  </div>
       
                </div>
              </article>
            </section>
        `
    }

    removePopup() {
        $("#popDimmed").remove();
    }
}